import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const box = css`
  padding-block: ${spacing(0.5)};
`

export const text = css`
  padding-inline: 0 !important;
`
